<!--
 * @Descripttion: 
 * @version: 
 * @Author: tangyuan
 * @Date: 2020-12-01 16:05:23
 * @LastEditors: tangyuan
 * @LastEditTime: 2020-12-03 16:06:29
-->
<template>
    <div class="logistic">
        <div class="section-box">
            <div class="section-item item-0"></div>
            <div class="section-item item-1">
                <div class="main-box">
                    <div class="content">
                        <div class="txt">
                            <p>与京东、菜鸟等仓储物流服务商长期密切合作，</p>
                            <p>能提供高效安全的投递服务，专业仓储体系和自动化分拣系统，能实现货物的闪电发货，</p>
                            <p>多年的酒类产品包装发货经验，为酒品提供最佳防护.</p>
                        </div>
                        <div class="advantage">
                            <div class="item" v-for="(item, index) in advantage" :key="index">
                                <div class="des">{{item}}</div>
                                <div class="img"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-item item-2">
                <div class="main-box">
                    <div class="title">
                        <img :src="titleImg[0]" alt="">
                    </div>
                    <div class="content">
                        <div class="item" v-for="(item, index) in service" :key="index">
                            <p class="p1">{{item.p1}}</p>
                            <p class="p2">{{item.p2}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section-item item-3">
                <div class="main-box">
                    <div class="title">
                        <img :src="titleImg[1]" alt="">
                    </div>
                    <div class="content">
                        <img :class="['img-'+index]" v-for="(item, index) in serviceImg" :key="index" :src="item" alt="">
                    </div>
                    <CommonBtn :span="'联系我们'"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CommonBtn from '@/components/common/btn'
    export default {
        components: {
            CommonBtn
        },
        data() {
            return {
                titleImg:[
                    require('../../assets/images/logistic/title1.png'),
                    require('../../assets/images/logistic/title2.png'),
                ],
                advantage:['订单及时处理率','准点发货率','库存精确度'],
                service:[
                    {
                        p1:'线上个人消',
                        p2:'费订单履行'
                    },
                    {
                        p1:'线下零售仓储',
                        p2:'及配送服务'
                    },
                    {
                        p1:'供应链网络布局',
                        p2:'及库存优化'
                    },
                    {
                        p1:'分拨中心',
                        p2:'设计和实施'
                    },
                    {
                        p1:'配送网络规',
                        p2:'划及优化'
                    },
                    {
                        p1:'全渠道',
                        p2:'物流整合'
                    }
                ],
                serviceImg:[
                    require('../../assets/images/logistic/image2.jpg'),
                    require('../../assets/images/logistic/image3.jpg'),
                    require('../../assets/images/logistic/image4.jpg'),
                    require('../../assets/images/logistic/image5.jpg'),
                ]
            }
        },
    }
</script>

<style lang="scss" scoped>
    .section-box{
        width: 100%;
        text-align: center;
        overflow: hidden;
        .main-box{
            overflow: hidden;
        }
        .section-item{
            .title{
                margin-top: 60px;
            }
            &.item-0{
                height: 720px;
                background: url(../../assets/images/logistic/banner.jpg) no-repeat 100% 100%;
            }
            &.item-1{
                height: 648px;
                background: #fbfbfb;
                .content{
                    text-align: left;
                    .txt{
                        font-size: 22px;
                        line-height: 48px;
                        margin-top: 148px;
                    }
                    .advantage{
                        display: flex;
                        margin-top: 120px;
                        justify-content: space-between;
                        .item{
                            width: 190px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            .des{
                                font-size: 20px;
                                font-weight: bold;
                            }
                            .img{
                                width: 187px;
                                height: 51px;
                                margin-top: 44px;
                                background: url(../../assets/images/logistic/image1.png) no-repeat 100% 100%;
                            }
                        }
                    }
                }
            }
            &.item-2{
                height: 962px;
                background: url(../../assets/images/logistic/bg.jpg) no-repeat 100% 100%;
                .content{
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    .item{
                        width: 372px;
                        height: 296px;
                        background: rgba(68, 69, 74, .5);
                        margin: 25px 0;
                        color: #fff;
                        font-size: 26px;
                        .p1{
                            margin: 104px 0 20px 0;
                        }
                    }
                }
            }
            &.item-3{
                height: 990px;
                background: #fbfbfb;
                .content{
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    img{
                        height: 292px;
                        margin: 10px 0;
                        &.img-0{
                            width: 697px;
                        }
                        &.img-1{
                            width: 512px;
                        }
                        &.img-2{
                            width: 520px;
                        }
                        &.img-3{
                            width: 686px;
                        }
                    }
                }
                .common-btn{
                    margin: 10px auto;
                }
            }
        }
    }
</style>